import { ref } from "vue"
import Tr from "@/translations"

/**
 * Arbol de categorias y subcategorias del catalogo, en el idioma activo.
 *
 * Dos diferencias respecto a getArticles.js y searcher.js, ambas deliberadas:
 * la URL se construye dentro de load() y no al crear el composable (si no, se
 * congela con el locale del momento y tras cambiar de idioma se sigue pidiendo
 * el anterior), e isLoading vive aqui para que el componente no tenga que
 * gestionarlo sin await.
 */
const getCategoriesAndSubcategories = () => {

    const categories = ref([])
    const error = ref(null)
    const isLoading = ref(false)

    const load = async () => {
        isLoading.value = true
        error.value = null

        try {
            const response = await fetch(process.env.VUE_APP_ROOT_API + "categories-and-subcategories/" + Tr.currentLocale)
            const data = await response.json()

            if (data.error || Number(data.code) !== 200) {
                categories.value = []
                error.value = { code: Number(data.code) || response.status, message: data.message }
                return
            }

            categories.value = data.results || []
        } catch (err) {
            categories.value = []
            // code 0 = no hubo respuesta del servidor
            error.value = { code: 0, message: err.message }
        } finally {
            isLoading.value = false
        }
    }

    return { categories, error, isLoading, load }
}

export default getCategoriesAndSubcategories
